import { render, staticRenderFns } from "./business-payment.vue?vue&type=template&id=1353d096&scoped=true&"
import script from "./business-payment.vue?vue&type=script&lang=js&"
export * from "./business-payment.vue?vue&type=script&lang=js&"
import style0 from "./business-payment.vue?vue&type=style&index=0&id=1353d096&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1353d096",
  null
  
)

export default component.exports